'use client';

import { ShippingBox } from 'assets/icons';
import {
  MidPanel,
  MidPanelPhone,
  LeftPanel,
  RightPanel,
} from 'components/shared/BottomBar';
import { useContext } from 'react';
import { DotSpinner, useModal, TypeformSnippet } from '..';
import { M1SelectionContext } from './M1SelectionProvider';
import { PrimaryButton } from 'components/shared/PrimaryButton';
import { CurrencySymbol, useFormatPrice } from 'hooks/pricing/useFormattedPrice';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { ProductPurchaseOption } from 'content/products';
import styles from './BottomBar.module.css';

const NotifyM1TFModal = ({
  trackingParams,
}: {
  className?: string;
  trackingParams?: {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
  };
}) => {
  return (
    <div className={styles.notifyModal}>
      <TypeformSnippet
        typeformId="J68hJztW"
        frameTitle="Book a call"
        className="typeform-container"
        trackingParams={trackingParams}
      />
    </div>
  );
};

export const BottomBar = () => {
  const {
    checkout,
    directCheckout,
    isLoading,
    currency,
    shippingEstimate,
    effectivePrice,
    outOfStock,
    store,
    productOption,
    product,
    products,
  } = useContext(M1SelectionContext);

  const variantId = products[productOption]?.plans[product]?.variantId ?? '';

  // US (M2 Live) prices are exclusive of taxes & shipping — flag it next to the
  // total, matching the tax-disclaimer pattern on other buy pages (e.g. Photon).
  // Shipping isn't charged on the subscription (Stripe limitation), so the note
  // drops "& shipping" for that option.
  const taxExclNote =
    store === ShopifyStore.US
      ? productOption === ProductPurchaseOption.membership
        ? '(Excl. taxes)'
        : '(Excl. taxes & shipping)'
      : null;

  const ModalClient = useModal();
  const formatPriceWithComma = useFormatPrice();

  const openTFmodal = () => {
    ModalClient.setCloseButtonTheme(`light`);

    ModalClient.set(
      <NotifyM1TFModal
        trackingParams={{
          utm_source: window.location.pathname,
          utm_medium: 'bottom-bar',
        }}
      />,
    );

    ModalClient.show();
  };

  const priceBlock = (
    <div className={styles['price-block']}>
      <p className={styles['total-price-single']}>
        {CurrencySymbol[currency]}
        {formatPriceWithComma(effectivePrice)}
      </p>
      {taxExclNote ? (
        <span className={styles['tax-disclaimer']}>{taxExclNote}</span>
      ) : null}
    </div>
  );

  return (
    <div className={`u-grid ${styles.root}`}>
      <LeftPanel>
        <div className={styles.shipping}>
          <ShippingBox />
          <p>{shippingEstimate}</p>
        </div>
      </LeftPanel>
      <MidPanel>{priceBlock}</MidPanel>
      <MidPanelPhone>
        <div className={styles['subtitle-text-btn']}>Total</div>
        {priceBlock}
      </MidPanelPhone>
      <RightPanel>
        <PrimaryButton
          className="gtm"
          onClick={outOfStock ? openTFmodal : checkout}
          disabled={isLoading}
          aria-busy={isLoading}
          data-buttontype={outOfStock ? 'notify me' : 'add to cart'}
          data-product={
            store === ShopifyStore.US ? 'Ultrahuman M2' : 'Ultrahuman M1'
          }
          data-variantId={variantId}
        >
          {isLoading ? (
            <DotSpinner color="#000000" />
          ) : outOfStock ? (
            'Notify me'
          ) : directCheckout ? (
            'Buy now'
          ) : (
            'Add to Cart'
          )}
          {/* {directCheckout ? 'Buy Now' : 'Add to Cart'} */}
        </PrimaryButton>
      </RightPanel>
    </div>
  );
};
